<template>
  <div class="relative w-full">
    <things-to-note1 :show="isCurrent(1)" @next="next" @skip="leave" />
    <things-to-note2 :show="isCurrent(2)" @next="next" @skip="leave" />
    <things-to-note3 :show="isCurrent(3)" @next="next" @skip="leave" />
  </div>
</template>

<script>
import audioPlayer from '@/mixins/audio-player';
import leave from '@/mixins/leave';

import ThingsToNote1 from '@/components/Stamp/ThingsToNote/ThingsToNote1.vue';
import ThingsToNote2 from '@/components/Stamp/ThingsToNote/ThingsToNote2.vue';
import ThingsToNote3 from '@/components/Stamp/ThingsToNote/ThingsToNote3.vue';

export default {
  name: 'StampThingsToNote',
  components: {
    ThingsToNote1,
    ThingsToNote2,
    ThingsToNote3,
  },
  mixins: [leave, audioPlayer],
  data: () => ({
    currentPageNo: 1,
  }),
  methods: {
    next() {
      const newPage = this.currentPageNo + 1;
      if (!this.lastScreen) {
        this.currentPageNo = newPage;
      } else {
        this.$events.goto('StampTutorial');
      }
      if (this.currentPageNo === 3) {
        this.playAudio('10');
      }
    },
    isCurrent(index) {
      return this.currentPageNo === index;
    },
  },
  computed: {
    lastScreen() {
      return this.currentPageNo >= 3;
    },
  },
};
</script>
